import React, { Component } from "react";
import i18n from "i18next";
import writeCookie from "../function/writeCookie";
import getCookie from "../function/getCookie";
import urlReplace from "../function/replaceUrl";
import { connect } from "react-redux";
import {
  product,
  login,
  countryList,
  browsingHistory,
  cart,
  loginPopup,
  mobileMenu,
  searchKeywords,
  loading,
  chosenFilter,
  myFav,
  sortByFitler
} from "../models";
import "../css/Search.css";
import { withRouter } from "react-router-dom";
import FilterBar from "../components/FilterBar/index";
import ProductBox from "../components/ProductBox";
import FilterBarMobile from "../components/FilterBarMobile";
import ScaleButton from "../components/FilterBarMobile/ScaleButton";
import { Helmet } from "react-helmet";
import Loading from "../components/Loading";

class Search extends Component {
  state = {
    lang: "zhTW",
    keywords: ""
  };

  isLoadingMore = false;
  async componentDidMount() {
    // 1. 先抓取網址上的參數值
    const textParams = window.location.search.replace("?", "");
    // console.log(textParams);
    // 2. 利用function修改為物件
    var params = this.parseQueryString(textParams);
    // console.log(params);
    const keywords = params.searchText;
    // 3. 修改標題文字
    this.setState({
      keywords: keywords
    });
    // 4. 同步排序狀態至 Redux（確保 loadMoreProducts 使用正確的排序參數）
    sortByFitler.actions.initSortBy(params.sortBy, params.sortDirection);

    // 5.發送API
    if (
      params.hasOwnProperty("searchText") &&
      params.hasOwnProperty("page") &&
      params.searchText.trim() !== ""
    ) {
      this.props.fetchSearch(keywords, params);
    }

    // 5. 新增滾動事件
    window.addEventListener("scroll", this.handleScroll);

    const lang =
      this.props.match.params.lang || getCookie("hk-emphasis-language"); //重整頁面先到cookie拿語系
    const isCheckoutPage = false;
    const isProductDetailsPage = true;
    const {
      fetchCountryList,
      fetchUser,
      showLoginPopup,
      showMobileMenu,
      fetchMenuCountryList,
      fetchCart,
      fetchMyFavList
    } = this.props;

    if (lang === "en") {
      i18n.changeLanguage("en");
      this.setState({
        lang: "en"
      });
      if (window.OneTrust) window.OneTrust.changeLanguage("en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      this.setState({
        lang: "zhTW"
      });
    }

    window.addEventListener("message", function (event) {
      if (event.data === "emphasisSuccess") {
        showLoginPopup(false); //登入成功後便關閉Popup畫面
        showMobileMenu(false); //登入成功後便關閉手機板Menu畫面
        fetchUser(isCheckoutPage, isProductDetailsPage);
      }
      return;
    });

    fetchCountryList();
    fetchMenuCountryList();
    fetchUser(isCheckoutPage, isProductDetailsPage);
    fetchCart();
    fetchMyFavList();
    window.addEventListener("message", e => {
      if (e.data === "HEADER_UPDATE_WISHLIST") {
        fetchMyFavList();
      }
      if (e.data === "HEADER_UPDATE_MINI_CART") {
        fetchCart();
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    if (this.isLoadingMore) return;
    const footer = document.getElementById("footer");
    const windowHeight = window.innerHeight;
    const { productRefinements } = this.props;
    if (
      window.pageYOffset > footer.offsetTop - windowHeight &&
      productRefinements
    ) {
      const totalPage =
        this.props.productRefinements.productListPageInfo.totalNumberOfPages;
      const keywords = this.state.keywords;
      const { searchProductList, activeSortBy, activePage } = this.props;

      if (totalPage > activePage) {
        this.isLoadingMore = true;
        this.props
          .loadMoreProducts(
            keywords,
            activePage,
            activeSortBy,
            searchProductList,
            null
          )
          .finally(() => {
            this.isLoadingMore = false;
          });
      }
    }
  };

  parseQueryString(query) {
    var vars = query.split("&");
    var query_string = {};
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      var key = decodeURIComponent(pair[0]);
      var value = pair[1];
      // If first entry with this name
      if (typeof query_string[key] === "undefined") {
        query_string[key] = decodeURIComponent(value);
        // If second entry with this name
      } else if (typeof query_string[key] === "string") {
        var arr = [query_string[key], decodeURIComponent(value)];
        query_string[key] = arr;
        // If third or later entry with this name
      } else {
        query_string[key].push(decodeURIComponent(value));
      }
    }
    return query_string;
  }

  async handleClickLang(event) {
    const { fetchCountryList, fetchMenuCountryList } = this.props;

    if (event.target.value === "en") {
      i18n.changeLanguage("en");
      writeCookie("eshop-hk-language", "en");
      this.setState({
        lang: "en"
      });
      /*塞en回url字串*/
      urlReplace(window.location.pathname, "tc", "en");
    } else {
      i18n.changeLanguage("zhTW"); //繁體
      writeCookie("eshop-hk-language", "zh_HK"); //香港網站
      this.setState({
        lang: "zhTW"
      });
      /*塞tc回url字串*/
      urlReplace(window.location.pathname, "en", "tc");
    }

    fetchCountryList(); // 切換語系，取得英文國家列表
    fetchMenuCountryList();
  }
  render() {
    const { keywords, lang } = this.state;
    const { isLoading } = this.props;
    const description =
      lang === "en"
        ? "At EMPHASIS, we embrace different styles and looks, resonating with the tastes of women from all walks of life. Our original designs are more than pretty accessories. They are designed to complete your look and express your individuality. We live in a world that imposes expectations on beauty. Our logo, featuring the stylised outline of an unconventional crown, is a proud symbol of our mission to challenge these expectations and let your inner strength shine through. Crown the Beautiful You."
        : "EMPHASIS 的原創珠寶不僅精緻瑰麗，我們獨特多變的設計更能圓滿妳的妝容服飾，展露自我風格。妳我縱使身處受標準審美限制的大時代，但我們品牌標誌上象徵富棱角的后冠能賦予妳勇於衝破枷鎖的力量，讓妳盡情綻放自己的獨特個性，閃爍耀眼。冠冕女性之美。";

    return (
      <div>
        <Helmet>
          {/* SEO */}
          {lang === "en" ? (
            <title>EMPHASIS&nbsp;&nbsp;|&nbsp;&nbsp;SEARCH</title>
          ) : (
            <title>EMPHASIS&nbsp;&nbsp;|&nbsp;&nbsp;搜索</title>
          )}
          <meta name="description" content={description} />
        </Helmet>
        <div id="header"></div>
        <div className="pageContent_wrap">
          <div className="pdtListingWBanners_wrap">
            <div>
              <div className="content-wrapper-wider">
                <span className="h2">{keywords}</span>
                <p></p>
              </div>
              <div className="pdtListing_wrap">
                <div className="content-wrapper-wider d-none d-md-block filter_wrap">
                  <FilterBar keywords={keywords} lang={lang} />
                </div>
                <div>
                  <ScaleButton />
                  <FilterBarMobile keywords={keywords} lang={lang} />
                </div>
                <div className="content-wrapper-wider">
                  <ProductBox keywords={keywords} />
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading && <Loading />}
        <footer id="footer"></footer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    product: state.product.productBookingUnit,
    isLoading: state.loading.isLoading,
    productRefinements: state.searchKeywords.productRefinements,
    activePage: state.searchKeywords.activePage,
    activeSortBy: state.sortByFilter.activeSortBy,
    searchProductList: state.searchKeywords.searchProductList
  };
};

const mapDispatchToProps = () => {
  return {
    fetchProduct: cbu => product.actions.fetchProduct(cbu),
    fetchCart: () => cart.actions.fetchCart(),
    fetchCountryList: () => countryList.actions.fetchCountryList(),
    fetchMenuCountryList: () => countryList.actions.fetchMenuCountryList(),
    fetchUser: (isCheckoutPage, isProductDetailsPage) =>
      login.actions.fetchUser(isCheckoutPage, isProductDetailsPage),
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode),
    fetchBrowsingHistory: () => browsingHistory.actions.fetchBrowsingHistory(),
    showLoginPopup: bool => loginPopup.actions.showLoginPopup(bool),
    showMobileMenu: bool => mobileMenu.actions.showMobileMenu(bool),
    fetchSearch: (keywords, data) =>
      searchKeywords.actions.fetchSearch(keywords, data),
    startLoading: bool => loading.actions.startLoading(bool),
    loadMoreProducts: (keywords, activePage, activeSortBy, searchProductList) =>
      chosenFilter.actions.loadMoreProducts(
        keywords,
        activePage,
        activeSortBy,
        searchProductList
      ),
    fetchMyFavList: () => myFav.actions.fetchMyFavList(),
    updateMyFav: (data, bool) => myFav.actions.updateMyFav(data, bool)
  };
};

const routerSearch = withRouter(Search);

export default connect(mapStateToProps, mapDispatchToProps)(routerSearch);
